<template>
  <div class="tools-table-events d-flex align-items-center gap-3">
    <span class="functional-1 text-neutral-700">
      {{ integrationEvents[0] }}
    </span>

    <bp-events-popper v-if="extraEvents > 0" :options="popperOptions">
      <bp-tag
        slot="reference"
        color="information"
        icon="fa-light fa-plus"
        trailing-icon="fa-light fa-chevron-down"
        :text="extraEvents"
      />

      <div class="bp-events-popper-body">
        <div v-for="(event, i) in integrationEvents" :key="i">{{ event }}</div>
      </div>
    </bp-events-popper>
  </div>
</template>

<script>
import get from "lodash/get";
import { mapState } from "vuex";

import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";

export default {
  components: { "bp-events-popper": Popper },
  props: {
    events: Array
  },
  data() {
    return {
      popperOptions: {
        placement: "right",
        modifiers: {
          offset: {
            offset: "0,10px"
          },
          flip: {
            enable: true
          }
        }
      }
    };
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    integrationEvents() {
      return [...this.events].map(e => this.formatEvent(e));
    },
    extraEvents() {
      return this.events.length - 1;
    }
  },
  methods: {
    formatEvent(event) {
      return get(
        this.typeEvents.find(t => t.id === event),
        "name",
        "-"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.bp-events-popper-body {
  z-index: 99999999;
  padding: 8px 12px;
  border-radius: 4px;
  height: fit-content;

  gap: 4px;
  display: flex;
  flex-direction: column;

  backdrop-filter: blur(12px);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
  background: var(--Surface-Cumulative-plus16, rgba(255, 255, 255, 0.64));
}
</style>
